import { InjectedIntl } from 'react-intl';

/**
 * Returns all messages starting with the provided ID followed by a number e.g.:
 * myarray.1, myarray.2, myarray.3.
 * Numbers must be sequential - its stops as soon as one is missing.
 * Has an arbitrary hard limit of 100 messages which can be increased if necessary.
 * @param messageArrayId the message prefix
 */
export function getArrayOfMessages(intl: InjectedIntl, messageArrayId: string): string[] {
    const messages = [];
    let i = 1;
    while (true) {
        const messageId = messageArrayId + '.' + i;
        const message = intl.formatMessage({ id: messageId });

        if (message === messageId) {
            // formatMessage falls back to outputting the input id if a message with that id isn't found
            break;
        }

        if (i > 100) {
            throw new Error('getArrayOfMessages has found over 100 messages.');
        }
        messages.push(message);
        i++;
    }
    return messages;
}

/**
 * As above, but parses any HTML within the messages.
 * Use a <FormattedHTMLMessage /> tag to render the output.
 */
export function getArrayOfHTMLMessages(intl: InjectedIntl, messageArrayId: string): string[] {
    const messages = [];
    let i = 1;
    while (true) {
        const messageId = messageArrayId + '.' + i;
        const message = intl.formatHTMLMessage({ id: messageId });

        if (message === messageId) {
            // formatHTMLMessage falls back to outputting the input id if a message with that id isn't found
            break;
        }

        if (i > 100) {
            throw new Error('getArrayOfMessages has found over 100 messages.');
        }
        messages.push(message);
        i++;
    }
    return messages;
}
